import { Link } from 'react-router-dom';
import { Button } from '@shared/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@shared/components/ui/card';

export default function NotFound() {
  return (
    <div className="flex items-center justify-center py-20">
      <Card className="max-w-lg w-full border border-border">
        <CardHeader>
          <CardTitle>404 - Page Not Found</CardTitle>
          <CardDescription>
            The page you’re looking for doesn’t exist or may have been moved.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="flex gap-3">
            <Button asChild>
              <Link to="/">Go to home page</Link>
            </Button>
            {/*<Button asChild variant="outline">
              <Link to="/service-requests">Service Requests</Link>
            </Button>*/}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}


